import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { downloadMobile } from '../actions/downloadMobile';
import { isGetStartedPhoneCardControlEnabled } from '../selectors/isGetStartedPhoneCardControlEnabled';

orchestrator(downloadMobile, () => {
    if (isGetStartedPhoneCardControlEnabled()) {
        window.open('https://go.microsoft.com/fwlink/?linkid=2109312');
    } else {
        window.open('https://go.microsoft.com/fwlink/?linkid=875115');
    }

    completeGetStartedTask(GetStartedTaskId.DownloadMobile);
});
